export const DD_MMM_YYYY_HH_MN_SS_A = 'DD/MMM/YYYY hh:mm:ss A';
export const DD_MMM_YYYY_HH_MN_A = 'DD/MMM/YYYY hh:mm A';
export const DD_MMM_YYYY = 'DD/MMM/YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const MM_YYYY = 'YYYY-MM';
export const MMM_YYYY = 'MMM/YYYY';

export const MONTH_YEAR = ['month', 'year'];

export const YEAR_MONTH = ['year', 'month'];

export const DATE_MONTH_YEAR = ['day', 'month', 'year'];

export const YEAR_MONTH_DATE = ['year', 'month', 'day'];

export const DISABLED_FUTURE_DATE_AND_DATE_MONTH_FORMAT = {
  disableFuture: true,
  inputFormat: DD_MMM_YYYY,
};

export const DISABLED_FUTURE_DATE_AND_MONTH_FORMAT = {
  disableFuture: true,
  inputFormat: MMM_YYYY,
};

export const MONTH_FORMAT = {
  inputFormat: MMM_YYYY,
};

export const DISABLED_PAST_DATE_AND_DATE_MONTH_FORMAT = {
  disablePast: true,
  inputFormat: DD_MMM_YYYY,
};
